import PopOverlay from 'PopOverlay'
import evt from 'event'
import $ from 'zepto'
import '../ui/confirmPop.less'

class ConfirmPop {
  constructor (text, config) {
    this.$elem = this.render(text)
    this.$pop = new PopOverlay(this.$elem, config)
    this.hasMask = (config || {}).hasMask
    this.maskElement = null
  }
  render (text) {
    var $elem = $(`
        <div class='confirm-container'>
          <div class="head">${text}</div>
          <div class="bottom-btn">
            <div class="bottom-btn-cancel pop-close">取消</div>
            <div class="bottom-btn-confirm">确认</div>
          </div>
        </div>
      `)

    $elem.find('.bottom-btn-confirm').click(() => {
      this.emit('confirm')
    })
    $elem.find('.bottom-btn-cancel').click(() => {      
      this.emit('cancel')
      this.removeMask()
    })
    return $elem
  }
  createMask() {
    if (!this.hasMask) return
    if (this.maskElement) return
    const mask = document.createElement('div')
    mask.style.position = 'fixed'
    mask.style.top = '0'
    mask.style.bottom = '0'
    mask.style.left = '0'
    mask.style.right = '0'
    mask.style.backgroundColor = 'rgba(0, 0, 0, .5)'
    mask.style.zIndex = '50'
    mask.setAttribute('data-mask', 'mask')
    this.maskElement = mask
    document.body.appendChild(mask)
  }
  removeMask() {
    const mask = document.querySelector('div[data-mask="mask"]')    
    if (mask) {
      this.maskElement = null
      mask.remove()
    }
  }

  show () {
    this.createMask()
    this.$pop.show()
  }
  hide () {
    this.removeMask()    
    this.$pop.hide()
  }
}

evt.mixin(ConfirmPop)

export default ConfirmPop



// WEBPACK FOOTER //
// ./src/mods/confirmPop.js